import React from "react"
import type { TicketPurchaseWithPurchaser } from "../../requests/ticketPurchases"
import { TicketRowDesktop } from "./TicketRowDesktop"

interface TicketsViewDesktopProps {
  tickets: TicketPurchaseWithPurchaser[]
  onRedeem: (ticketId: number) => void
  onUnredeem: (ticketId: number) => void
  onDelete: (ticketId: number) => void
  onCancelRefund: (ticket: TicketPurchaseWithPurchaser) => void
  isRedeemLoading: boolean
  isUnredeemLoading: boolean
  isDeleteLoading: boolean
  isCancelRefundLoading: boolean
}

export const TicketsViewDesktop: React.FC<TicketsViewDesktopProps> = ({
  tickets,
  onRedeem,
  onUnredeem,
  onDelete,
  onCancelRefund,
  isRedeemLoading,
  isUnredeemLoading,
  isDeleteLoading,
  isCancelRefundLoading,
}) => (
  <div className="hidden xl:block bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
              Ticket ID
            </th>
            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
              Purchaser
            </th>
            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
              Purchase Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
              Amount
            </th>
            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {tickets.map((ticket) => (
            <TicketRowDesktop
              key={ticket.id}
              ticket={ticket}
              onRedeem={onRedeem}
              onUnredeem={onUnredeem}
              onDelete={onDelete}
              onCancelRefund={onCancelRefund}
              isRedeemLoading={isRedeemLoading}
              isUnredeemLoading={isUnredeemLoading}
              isDeleteLoading={isDeleteLoading}
              isCancelRefundLoading={isCancelRefundLoading}
            />
          ))}
        </tbody>
      </table>
    </div>
  </div>
)
